import HighlightedLine from '@/editor/entities/2d/highlightedLine';
import { LineSeg2d } from '@/editor/math/LineSeg2d';

export class HighlightedLineManager {
  private _highlightedLines: HighlightedLine[];

  constructor() {
    this._highlightedLines = [];
  }

  get highlightedLines() {
    return this._highlightedLines;
  }

  addHighlightedLines(segs: LineSeg2d[]) {
    for (const seg of segs) {
      const highlightedLine = new HighlightedLine([seg.start, seg.end]);
      this._highlightedLines.push(highlightedLine);
    }
  }

  clearHighlightedLines() {
    for (const highlightedLine of this._highlightedLines) {
      highlightedLine.dispose();
    }
    this._highlightedLines.length = 0;
  }
}
